import styled from "styled-components";

const And = styled.span`
  font-family: "NimbusRomNo";
  line-height: 1.2;
`;

export default And;
